import 'core-js';
import 'react-app-polyfill/stable';
import React from 'react';
import ReactDOM from 'react-dom';
import { Provider } from 'react-redux';
import { BrowserRouter } from 'react-router-dom';
import TagManager from 'react-gtm-module'

import * as serviceWorker from './serviceWorker';
import store from './store/createStore';
import AppRedesign from './App';

import './trusted-security-policies';
import './styles/index.scss';

// Initialise gtm
const gtmId = window.LAYOUT_DATA?.gtmData?.tagIds?.[0]
if (gtmId) {
  TagManager.initialize({
    gtmId,
  })
}

const app = (
  <Provider store={store}>
    <BrowserRouter>
      <AppRedesign />
    </BrowserRouter>
  </Provider>
);

ReactDOM.render(app, document.getElementById('App__payment'));

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();
